import { supabase } from '../config/supabaseClient'

export { supabase }

export const handleError = (error, context) => {
  console.error(`Error in ${context}:`, error)
  throw new Error(error.message || `Failed to ${context}`)
}

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A'
  const date = new Date(dateString)
  return date.toLocaleDateString('en-IN', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
